import getAPIDomain from '@signal/utils/env/apiDomain';
export var API_URL = getAPIDomain('/branding/api');
export var API_VERSION = '1';